module.exports = __webpack_public_path__ + "img/list_booking_icon.79a9db82.svg";